import { BottomNavigation, BottomNavigationAction, Paper, useMediaQuery, useTheme } from '@mui/material';
import { ViewList, Map as MapIcon, AssignmentInd } from '@mui/icons-material';
import { DISPATCH } from './dispatchTheme';

export type DispatchMobileView = 'queue' | 'map' | 'detail';

interface DispatchMobileNavProps {
  value: DispatchMobileView;
  onChange: (view: DispatchMobileView) => void;
  detailDisabled?: boolean;
}

export default function DispatchMobileNav({ value, onChange, detailDisabled }: DispatchMobileNavProps) {
  const theme = useTheme();
  const show = useMediaQuery(theme.breakpoints.down('lg'));

  if (!show) return null;

  return (
    <Paper
      elevation={8}
      sx={{
        position: 'sticky',
        bottom: 0,
        zIndex: 20,
        borderTop: `1px solid ${DISPATCH.border}`,
        borderRadius: 0,
        pb: 'env(safe-area-inset-bottom, 0px)',
      }}
    >
      <BottomNavigation
        value={value}
        onChange={(_, v) => v && onChange(v)}
        showLabels
        sx={{
          height: 56,
          bgcolor: DISPATCH.bgPanel,
          '& .MuiBottomNavigationAction-root': {
            minWidth: 0,
            py: 0.75,
            color: 'text.secondary',
            '&.Mui-selected': { color: DISPATCH.primary },
          },
          '& .MuiBottomNavigationAction-label': {
            fontSize: '0.68rem',
            fontWeight: 700,
            '&.Mui-selected': { fontSize: '0.68rem' },
          },
        }}
      >
        <BottomNavigationAction label="Queue" value="queue" icon={<ViewList />} />
        <BottomNavigationAction label="Live Map" value="map" icon={<MapIcon />} />
        <BottomNavigationAction label="Details" value="detail" icon={<AssignmentInd />} disabled={detailDisabled} />
      </BottomNavigation>
    </Paper>
  );
}
